import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import SimpleModal from 'components/SimpleModal';
import Stack from 'components/Stack';
import Alert, { AlertTypes } from 'components/Alert';
import { getCardWithAttendeePills } from './utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ConfirmAttendeeStatusChangeModal(_ref) {
  var isLoading = _ref.isLoading,
    conflictUsers = _ref.conflictUsers,
    overCapacity = _ref.overCapacity,
    onClose = _ref.onClose,
    onConfirm = _ref.onConfirm;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var hasConflictUsers = conflictUsers.length > 0;
  var showOverCapacityAlert = typeof (overCapacity === null || overCapacity === void 0 ? void 0 : overCapacity.projectedActiveAttendeesCount) === 'number' && typeof (overCapacity === null || overCapacity === void 0 ? void 0 : overCapacity.capacity) === 'number';
  var alerts = [showOverCapacityAlert && /*#__PURE__*/_jsx(Trans, {
    i18nKey: "modal_update_attendees_alert_over_session_capacity",
    values: {
      sessionCapacity: overCapacity.capacity,
      count: overCapacity.projectedActiveAttendeesCount
    }
  }), hasConflictUsers && /*#__PURE__*/_jsx(Trans, {
    i18nKey: "modal_update_attendees_alert_booking_conflict",
    count: conflictUsers.length
  })].filter(Boolean);
  return /*#__PURE__*/_jsx(SimpleModal, {
    width: "wide",
    title: t('modal_update_attendees_title'),
    body: /*#__PURE__*/_jsxs(Stack, {
      spacing: "s",
      children: [alerts.map(function (alert, index) {
        return /*#__PURE__*/_jsx(Alert, {
          type: AlertTypes.FAIL,
          children: alert
        }, index);
      }), hasConflictUsers && getCardWithAttendeePills({
        headingText: t('modal_confirm_attendees_already_booked_members_title'),
        isTeamSelection: false,
        users: conflictUsers
      })]
    }),
    buttons: [{
      label: t('actions_cancel'),
      onClick: onClose,
      isDisabled: isLoading
    }, {
      label: t('actions_update'),
      onClick: onConfirm,
      variant: 'primary',
      isLoading: isLoading
    }],
    onClose: onClose
  });
}